import { FC } from "react";
import Ad from "Components/Ad";
import { MPUWrapper, MPUInnerWrapper } from "./SideBarMPU.styled";

interface Props {
  className: string;
  id: string;
}

const MPU: FC<Props> = ({ className, id }) => {
  return (
    <MPUWrapper>
      <MPUInnerWrapper>
        <Ad className={className} id={id} width="100%" height="200" />
      </MPUInnerWrapper>
    </MPUWrapper>
  );
};

export default MPU;
